import { render, staticRenderFns } from "./OrderLogBox.vue?vue&type=template&id=73e3bdc4&scoped=true"
import script from "./OrderLogBox.vue?vue&type=script&lang=js"
export * from "./OrderLogBox.vue?vue&type=script&lang=js"
import style0 from "./OrderLogBox.vue?vue&type=style&index=0&id=73e3bdc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e3bdc4",
  null
  
)

export default component.exports